import React, { useMemo } from "react"
import CustomModal from "../basics/interface/CustomModal"
import { StatRow } from "../atelier/AtelierSearchTotal"
import { formatNumber } from "../../utilities/Addons"
import { COLORS } from "../../utilities/Constants"

// Totaux de la recherche dépannage (V2). Même langage que le modal Totaux de
// l'atelier : CustomModal + StatRow partagé, ventilation par composante du
// prix puis total en avant. Le calcul est une somme synchrone sur les
// résultats déjà chargés (le spinner du legacy était du théâtre) : une fiche
// présente dans les DEUX tableaux ne compte sa livraison qu'une fois.
const DepSearchTotal = ({ closeModal, deps, livs }) => {
	const totaux = useMemo(() => {
		const livIds = new Set(livs.map((l) => l.id))
		const t = { base: 0, hSup: 0, gard: 0, liv: 0, resti: 0, autre: 0, tot: 0 }
		deps.forEach((dep) => {
			t.base += dep.baseTot
			t.hSup += dep.hSupTot
			t.gard += dep.gardTot
			t.resti += dep.restiTot
			t.autre += dep.autreTot
			t.tot += livIds.has(dep.id)
				? dep.totalFinal - dep.livTot
				: dep.totalFinal
		})
		livs.forEach((liv) => {
			t.liv += liv.livTot
			t.tot += liv.livTot
		})
		return t
	}, [deps, livs])

	const chf = (v) => formatNumber(Math.round(100 * v) / 100)

	return (
		<CustomModal
			title="Totaux"
			onClose={closeModal}
			showFooter={false}
			maxWidth={460}
		>
			{/* Périmètre de la somme — sans lui, le chiffre ne dit pas sur quoi
			    il porte. */}
			<div
				style={{
					marginBottom: 6,
					fontSize: 11,
					fontWeight: 600,
					letterSpacing: "0.08em",
					textTransform: "uppercase",
					color: COLORS.textLight,
				}}
			>
				{deps.length} dépannage{deps.length > 1 ? "s" : ""} ·{" "}
				{livs.length} livraison{livs.length > 1 ? "s" : ""}
			</div>
			<StatRow label="Tarif de base" value={chf(totaux.base)} />
			<StatRow label="Heures supp." value={chf(totaux.hSup)} />
			<StatRow label="Gardiennage" value={chf(totaux.gard)} />
			<StatRow label="Livraison" value={chf(totaux.liv)} />
			<StatRow label="Restitution" value={chf(totaux.resti)} />
			<StatRow label="Autre" value={chf(totaux.autre)} />
			<StatRow label="Total" value={chf(totaux.tot)} strong />
		</CustomModal>
	)
}

export default DepSearchTotal
